import 'core-js';

import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './components/App';

import './fontPreLoader';

import 'normalize.css';
import 'react-virtualized/styles.css';
// Vendored from `@perion-undertone/ut-ui-resources@1.4.0`. The published npm
// tarball is missing the `utIcon/` folder despite declaring it in `files`,
// so resolving the package path fails on the deploy build. The icon font
// itself is unchanged; we keep a local copy to make the bundle self-contained.
import '../assets/utIcon/ut-icon.css';
import '../stylesheets/main.scss';

const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
const inspectUpdates = urlParams.get('inspectUpdates');

if (process.env.NODE_ENV !== 'production' && inspectUpdates) {
    const {whyDidYouUpdate} = require('why-did-you-update');
    whyDidYouUpdate(React);
}

const prerenderer = async () => {
    const initialState = {};
    try{
        const res = await fetch(`/config`);
        const config = await res.json();
        window.clientConfig = config;
    } catch (err) {
        initialState.app = {error: 'App could not load'};
    }

    const container = document.getElementById('app');
    const root = createRoot(container);
    root.render(<App initialState={initialState} />);
};

prerenderer();
